import React from 'react';

const SegmentedControl = ({ items = [], value, onChange, className = '' }) => {
  const handleKeyDown = (e, index) => {
    if (!items.length) return;
    if (e.key === 'ArrowRight') {
      e.preventDefault();
      const next = (index + 1) % items.length;
      onChange?.(items[next].id);
    } else if (e.key === 'ArrowLeft') {
      e.preventDefault();
      const prev = (index - 1 + items.length) % items.length;
      onChange?.(items[prev].id);
    }
  };

  return (
    <div
      className={`inline-flex items-center space-x-1 p-1 rounded-xl bg-gradient-to-b from-white/50 to-slate-100/60 shadow-inner backdrop-blur-sm ${className}`}
      role="tablist"
      aria-label="Segmented control"
    >
      {items.map((item, idx) => {
        const isActive = item.id === value;
        return (
          <button
            key={item.id}
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange?.(item.id)}
            onKeyDown={(e) => handleKeyDown(e, idx)}
            className={
              `px-6 py-2 rounded-lg text-sm font-medium transition-all duration-300 outline-none ` +
              (isActive
                ? 'bg-slate-100/70 text-primary-700'
                : 'text-slate-600 hover:text-slate-900 hover:bg-white/40')
            }
          >
            {item.label}
          </button>
        );
      })}
    </div>
  );
};

export default SegmentedControl;